module.exports = __webpack_public_path__ + "static/media/wd12.bd7ded63.jpeg";